import { configureStore, PreloadedState } from '@reduxjs/toolkit'

import { jdePriceStatusMiddleware } from '../middleware/jdePriceStatusMiddleware'
import { signalRMiddleware } from '../middleware/signalRMiddleware'
import { rootReducer } from '../reducers'

export type RootState = ReturnType<typeof rootReducer>

// Create a function to set up the store, allowing for preloaded state (useful for testing)
export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat(signalRMiddleware)
        .concat(jdePriceStatusMiddleware.middleware),
    preloadedState, // Allow preloaded state for testing
    reducer: rootReducer,
  })
}

// Default store for the application
export const store = setupStore()

// Export types for use in the app and tests
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
